var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"closeButton"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.click}},[_c('i',{staticClass:"fas fa-times"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }